// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3x0_V","selected":"Chip_selected__2zhvO"};